export const PRICE_BY_ID: Record<string, number> = {
  // Essential
  price_1Shmkw53YIqi52EpPzMyMKmn: 50,
  price_1Shmnc53YIqi52EpP2ZiH5fs: 40,
  price_1Shmo153YIqi52EpN0q0ZYIM: 30,
  price_1ShmoC53YIqi52EplfiG8VB2: 25,
  // Premium
  price_1SbFT353YIqi52Epb9WL8laA: 185,
  price_1ShmpV53YIqi52EpkBu3vC36: 90,
  price_1Shmqc53YIqi52EpuIfREZGs: 85,
  price_1Shmpn53YIqi52EpN1nyoIab: 80,
  // Dev catalog (env-seeded placeholders for local/test)
  price_DEV_AUD_500_REPLACE_ME: 5,
  price_DEV_AUD_1000_REPLACE_ME: 10,
  price_DEV_AUD_1500_REPLACE_ME: 15,
  price_DEV_AUD_2000_REPLACE_ME: 20,
};

export const TIER_LABEL_BY_PRICE_ID: Record<string, string> = {
  price_1Shmkw53YIqi52EpPzMyMKmn: "Essential",
  price_1Shmnc53YIqi52EpP2ZiH5fs: "Essential",
  price_1Shmo153YIqi52EpN0q0ZYIM: "Essential",
  price_1ShmoC53YIqi52EplfiG8VB2: "Essential",
  price_1SbFT353YIqi52Epb9WL8laA: "Premium",
  price_1ShmpV53YIqi52EpkBu3vC36: "Premium",
  price_1Shmqc53YIqi52EpuIfREZGs: "Premium",
  price_1Shmpn53YIqi52EpN1nyoIab: "Premium",
  price_DEV_AUD_500_REPLACE_ME: "Dev",
  price_DEV_AUD_1000_REPLACE_ME: "Dev",
  price_DEV_AUD_1500_REPLACE_ME: "Dev",
  price_DEV_AUD_2000_REPLACE_ME: "Dev",
};

export const TIER_VARIANT_BY_PRICE_ID: Record<string, "default" | "secondary"> = {
  price_1Shmkw53YIqi52EpPzMyMKmn: "secondary",
  price_1Shmnc53YIqi52EpP2ZiH5fs: "secondary",
  price_1Shmo153YIqi52EpN0q0ZYIM: "secondary",
  price_1ShmoC53YIqi52EplfiG8VB2: "secondary",
  price_1SbFT353YIqi52Epb9WL8laA: "default",
  price_1ShmpV53YIqi52EpkBu3vC36: "default",
  price_1Shmqc53YIqi52EpuIfREZGs: "default",
  price_1Shmpn53YIqi52EpN1nyoIab: "default",
  price_DEV_AUD_500_REPLACE_ME: "secondary",
  price_DEV_AUD_1000_REPLACE_ME: "secondary",
  price_DEV_AUD_1500_REPLACE_ME: "secondary",
  price_DEV_AUD_2000_REPLACE_ME: "secondary",
};

export const DEFAULT_PRICE_PER_DOMAIN = 185;
export const DEFAULT_TIER_LABEL = "Premium";

export const getDomainPrice = (domain: {
  stripe_price_id?: string | null;
  stripePriceId?: string | null;
  promo_price?: number | null;
  promoPrice?: number | null;
  tier?: string | null;
}) => {
  const promoValue =
    typeof domain.promo_price === "number"
      ? domain.promo_price
      : typeof domain.promoPrice === "number"
      ? domain.promoPrice
      : null;
  if (typeof promoValue === "number" && promoValue > 0) {
    return promoValue;
  }
  const priceId = domain.stripe_price_id || domain.stripePriceId || "";
  if (PRICE_BY_ID[priceId] !== undefined) return PRICE_BY_ID[priceId];
  if (domain.tier === "dev") return 5;
  return DEFAULT_PRICE_PER_DOMAIN;
};

export const getDomainLabel = (domain: {
  stripe_price_id?: string | null;
  stripePriceId?: string | null;
  promo_price?: number | null;
  promoPrice?: number | null;
  tier?: string | null;
}) => {
  const priceId = domain.stripe_price_id || domain.stripePriceId || "";
  const base = TIER_LABEL_BY_PRICE_ID[priceId] ?? (domain.tier === "dev" ? "Dev" : DEFAULT_TIER_LABEL);
  const promoValue =
    typeof domain.promo_price === "number"
      ? domain.promo_price
      : typeof domain.promoPrice === "number"
      ? domain.promoPrice
      : null;
  if (typeof promoValue === "number" && promoValue > 0) {
    return `${base} (Promo)`;
  }
  return base;
};
